import React, { ReactNode } from 'react';

interface Props {
  name: string;
  id?: string;
  children?: ReactNode;
}

export const SettingsTabContent: React.FunctionComponent<Props> = ({ name, id, children }) => {
  return (
    <div id={id} className="settings-tab-content">
      {name && <div className="settings-tab-name haiui-heading-04-med">{name}</div>}
      {children}
    </div>
  );
};
